import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxLabelWrapperFn = /* @__PURE__ */ createRecipe('checkbox-label-wrapper', {
  "direction": "column"
}, [])

const checkboxLabelWrapperVariantMap = {
  "direction": [
    "row",
    "column"
  ]
}

const checkboxLabelWrapperVariantKeys = Object.keys(checkboxLabelWrapperVariantMap)

export const checkboxLabelWrapper = /* @__PURE__ */ Object.assign(memo(checkboxLabelWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxLabelWrapper',
  __getCompoundVariantCss__: checkboxLabelWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxLabelWrapperVariantKeys,
  variantMap: checkboxLabelWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxLabelWrapperVariantKeys)
  },
  getVariantProps: checkboxLabelWrapperFn.getVariantProps,
})